export function isValidPhone(input: string): boolean {
  const cleaned = input.replace(/\s|-/g, '');
  const phoneRegex = /^(\+?\d{1,4})?[\s.-]?\(?\d{2,4}\)?[\s.-]?\d{3,4}[\s.-]?\d{3,4}$/;
  return phoneRegex.test(cleaned);
}
